module.exports = __webpack_public_path__ + "static/python-1f712ee80850c05a80bf7c441e4060d7.png";